module.exports = __webpack_public_path__ + "static/rabbit1-0ac6ec409c2aba4be68686f82b0a249c.png";